import appConfig from 'app-config';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

const capabilityPrefix = appConfig.portalCode === 'GPA' ? 'gateway' : '';

export default {
    getRAPrefillDetailsMLByJobNumber: (jobNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAPrefillDetailsMLByJobNumber', [jobNumber], additionalHeaders);
    },
    getRAContingencyDetailsMLByJobNumber: (jobNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAContingencyDetailsMLByJobNumber', [jobNumber], additionalHeaders);
    },
    getRAHomeInspectionDetailsMLByJobNumber: (jobNumber, additionalHeaders = {}) => {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAHomeInspectionDetailsMLByJobNumber', [jobNumber], additionalHeaders);
    },
    getRAConsumerReportsMLByJobNumber: (jobNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAConsumerReportsMLByJobNumber', [jobNumber], additionalHeaders);
    },
    getRAPriorCarrierMLByJobNumber: (jobNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAPriorCarrierDetailsMLByJobNumber', [jobNumber], additionalHeaders);
    },
    getRACompanyUseMLByJobNumber: (jobNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRACompanyUseDetailsMLByJobNumber', [jobNumber], additionalHeaders);
    },
    getRAPrefillDetailsMLByPolicyNumber: (policyNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAPrefillDetailsMLByPolicyNumber', [policyNumber], additionalHeaders);
    },
    getRAContingencyDetailsMLByPolicyNumber: (policyNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAContingencyDetailsMLByPolicyNumber', [policyNumber], additionalHeaders);
    },
    getRAHomeInspectionDetailsMLByPolicyNumber: (policyNumber, additionalHeaders = {}) => {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAHomeInspectionDetailsMLByPolicyNumber', [policyNumber], additionalHeaders);
    },
    getRAConsumerReportsMLByPolicyNumber: (policyNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAConsumerReportsMLByPolicyNumber', [policyNumber], additionalHeaders);
    },
    getRAPriorCarrierMLByPolicyNumber: (policyNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRAPriorCarrierDetailsMLByPolicyNumber', [policyNumber], additionalHeaders);
    },
    getRACompanyUseDetailsMLByPolicyNumber: (policyNumber, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getRACompanyUseDetailsMLByPolicyNumber', [policyNumber], additionalHeaders);
    },
    getMyriadSSOURL: (additionalHeaders = {}) => {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getMyriadSSOURL', [], additionalHeaders);
    },
    getOpenContingenciesForUser: (limit, searchRequest, additionalHeaders = {}) => {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}riskanalysis`), 'getOpenContingenciesForUser', [limit, searchRequest], additionalHeaders);
    }
};
